import { MatchingHistory } from '../types/matching';
import { fetcher, fetcherPatch } from '../util/axios';

export const getFromRecommendedUsers = async (memberId:number):Promise<MatchingHistory[]> => {
  const fromData =  await fetcher(`member/matching-history/from/${memberId}`);
  return fromData.data as MatchingHistory[];
};
export const getToRecommendUsers = async (memberId:number):Promise<MatchingHistory[]> => {
  const toData = await fetcher(`member/matching-history/to/${memberId}`);
  return toData.data as MatchingHistory[];
};
export const setIsAccept = async (isAccept:boolean, historyId:number, memberId:number) : Promise<void> => {
  await fetcherPatch(`member/matching-history/${historyId}/${memberId}`, { isAccept });
};
